import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProviderReviewItem } from 'services/providers/providers.types';

import { ProviderState } from './provider.types';

const initialState: ProviderState = {
  reviews: []
};

const providerSlice = createSlice({
  initialState,
  name: 'provider',
  reducers: {
    setReviews: (state, action: PayloadAction<ProviderReviewItem[]>) => {
      state.reviews = action.payload;
    }
  }
});

export const { setReviews } = providerSlice.actions;

export default providerSlice.reducer;
